import { ValidationSetting } from '@Types/api/form';

const findValidationSetting = (
  paramId: number,
  validationSettings: Array<ValidationSetting>
): ValidationSetting | undefined => {
  return validationSettings.find((setting) => setting.paramId === paramId);
};

export default findValidationSetting;
